import "./AISolutionsReceptionistChat.module.css";
import Header from "@/reusable_sections/Header";
import Automation from "./sections/Automation";
import Console from "./sections/Console";
import Missedcalls from "./sections/Missedcalls";
import Industries from "./sections/Industries";
import Dashboard from "./sections/Dashboard";
import Footer from "@/reusable_sections/Footer";
export default function AISolutionsReceptionistChatPage() {
  return <div>
      <Header />
      <Console />
      <Missedcalls />
      <Automation />
      <Industries />
      <Dashboard />
      <Footer />
    </div>;
}